import React from 'react'
import { CustomNodeModel } from '../CustomNode/CustomNodeModel'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
// import { keys } from 'lodash'

export default ({ children, addNode, diagramEngine }) => (
  <div
    className={cn(sLay.flex, sLay['layout-column'])}
    onDrop={event => {
      const data = JSON.parse(event.dataTransfer.getData('storm-diagram-node'))
      const node = new CustomNodeModel(data.nodeType)
      const points = diagramEngine.getRelativeMousePoint(event)
      node.x = points.x
      node.y = points.y
      addNode(node)
    }}
    onDragOver={event => {
      event.preventDefault()
    }}
  >
    {children}
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/DropLayer/DropLayer.jsx